import { toRaw } from 'vue'
import { GridOption } from '../grid-option'

function looksLikeGridOption(value: unknown): value is GridOption {
  if (value == null || typeof value !== 'object') {
    return false
  }
  const candidate = value as GridOption
  return typeof candidate.module === 'string'
    && Array.isArray(candidate.columns)
    && candidate.columns.length > 0
}

export function isGridOption(value: unknown): value is GridOption {
  if (value == null) {
    return false
  }
  const raw = toRaw(value)
  const Ctor = globalThis.GridOption
  if (Ctor && raw instanceof Ctor) {
    return true
  }
  return looksLikeGridOption(raw)
}
